// v1.0.0 - 2026-01-27 - Member layout component

import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import type { User } from '@/types'
import type { CERSettings } from '@/lib/ti-calculator/types'

interface MemberLayoutProps {
  user: User
  cerSettings: CERSettings | null
  onLogout: () => void
}

export function MemberLayout({ user, cerSettings, onLogout }: MemberLayoutProps) {
  return (
    <div className="flex h-screen overflow-hidden bg-[var(--color-bg-secondary)]">
      {/* Sidebar */}
      <Sidebar
        role="member"
        cerName={cerSettings?.branding.name || user.cer_name}
        cerLogo={cerSettings?.branding.logo_url}
      />

      {/* Main Content */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Header */}
        <Header user={user} onLogout={onLogout} />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default MemberLayout
